import { Reveal, SectionTag } from "./shared";

const SPECS = [
  ["Model", "X8 Violent Fan"],
  ["Motor", "Brushless, up to 110,000 RPM"],
  ["Jet velocity", "Up to 33 m/s"],
  ["Fan", "13-blade aviation aluminum alloy"],
  ["Speed control", "Infinitely variable + 3-level display"],
  ["Battery", "8,000 mAh Li-ion"],
  ["Charging", "USB-C fast recharge"],
  ["Voltage", "7.4 V"],
  ["Weight", "420 g"],
  ["Body", "ABS + silicone, Iron Gray"],
  ["Extras", "Reverse-suction ready with vacuum kit"],
  ["In the box", "Unit, USB-C cable"],
];

export const Specs = () => (
  <section id="specs" data-testid="specs-section" className="border-t border-steel">
    <div className="mx-auto grid max-w-[1600px] gap-4 px-5 py-24 md:px-10 md:py-36 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal className="flex h-full flex-col">
          <SectionTag index="06" label="Tech Sheet" />
          <h2 className="mt-6 font-display text-3xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
            Full<br /><span className="text-volt">send.</span>
          </h2>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-smoke md:text-base">
            No marketing fluff. Here is the raw hardware sheet, straight off the factory floor.
          </p>
          <div className="group relative mt-10 flex-1 overflow-hidden border border-steel">
            <img
              src="/assets/cj-1.jpg"
              alt="The exact X8 Violent Fan unit that ships, Iron Gray finish"
              loading="lazy"
              className="h-[280px] w-full object-cover transition-transform duration-700 group-hover:scale-105 md:h-full md:min-h-[320px]"
            />
            <div className="absolute inset-x-0 bottom-0 border-t border-white/10 bg-ink/70 px-5 py-3 font-mono text-[10px] tracking-[0.25em] uppercase text-smoke backdrop-blur-md">
              The exact unit that ships — Iron Gray
            </div>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <dl className="border border-steel bg-carbon" data-testid="specs-table">
          {SPECS.map(([k, v], i) => (
            <div
              key={k}
              data-testid={`spec-row-${i}`}
              className="group flex items-center justify-between gap-6 border-b border-steel px-6 py-4 transition-colors duration-200 last:border-b-0 hover:bg-ink md:px-10 md:py-5"
            >
              <dt className="font-mono text-[10px] tracking-[0.3em] uppercase text-smoke transition-colors duration-200 group-hover:text-volt md:text-xs">
                {k}
              </dt>
              <dd className="text-right font-mono text-xs font-bold md:text-sm">{v}</dd>
            </div>
          ))}
        </dl>
      </Reveal>
    </div>
  </section>
);
